/**
 * This file is to be used as a fallback for if the PageConfigComponentsQuery fails.
 */
import { PageConfig_PageName as PageName } from '__generated__/graphql-types';

import type { PageConfig_ComponentConfigFragment as PageConfigComponent } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfigComponentsQuery';

export const PageConfigFallbackData: Partial<Record<PageName, PageConfigComponent[]>> = {
  [PageName.ConsumerLoggedInHome]: [
    {
      id: 'PageConfig_OnboardingResultsHeaderComponent',
      __typename: 'PageConfig_OnboardingResultsHeaderComponent',
    },
    {
      id: 'PageConfig_EnrolledProductsComponent',
      __typename: 'PageConfig_EnrolledProductsComponent',
    },
    {
      id: 'degrees',
      __typename: 'PageConfig_PremiumCollectionComponent',
    },
    {
      id: 'PageConfig_PromoUnitsComponent',
      __typename: 'PageConfig_PromoUnitsComponent',
    },
    {
      id: 'PageConfig_DomainPillsComponent',
      __typename: 'PageConfig_DomainPillsComponent',
    },
    {
      id: 'mastertracks',
      __typename: 'PageConfig_PremiumCollectionComponent',
    },
  ] as PageConfigComponent[],
  [PageName.EnterpriseHome]: [
    {
      id: 'PageConfig_OnboardingResultsHeaderComponent',
      __typename: 'PageConfig_OnboardingResultsHeaderComponent',
    },
    {
      id: 'PageConfig_EnrolledProductsComponent',
      __typename: 'PageConfig_EnrolledProductsComponent',
    },
    {
      id: 'PageConfig_SkillsFocusComponent',
      __typename: 'PageConfig_SkillsFocusComponent',
    },
    {
      id: 'PageConfig_SkillSetCardsComponent',
      __typename: 'PageConfig_SkillSetCardsComponent',
    },
    {
      id: 'PageConfig_DomainPillsComponent',
      __typename: 'PageConfig_DomainPillsComponent',
    },
  ] as PageConfigComponent[],
  [PageName.ConsumerSearch]: [
    {
      id: 'PageConfig_SearchFrameComponent',
      __typename: 'PageConfig_SearchFrameComponent',
    },
  ] as PageConfigComponent[],
  [PageName.BrowseEqpFree]: [
    {
      id: 'PageConfig_SearchFrameComponent',
      __typename: 'PageConfig_SearchFrameComponent',
    },
  ] as PageConfigComponent[],
};
